import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const RoadMap = () => {
    
    useEffect(() => {
        AOS.init({ duration: 2000 });
    });

    return (
        <section className="Roadmap" id="Roadmap">
            <h2>Roadmap</h2>
            <div className="roadmap__items">
                <div data-aos="fade-right" data-duration="500" className="roadmap__item">
                    <div>
                        <h5>Phase 1</h5>
                    </div>
                    <div className="bg-overlay"></div>
                    <span className="side__line"></span>
                    <ul>
                        <li>Platform UX/UI & Architecture</li>
                        <li>Token development</li>
                        <li>Publish litepaper</li>
                        <li>Seed / Private Token Sale</li>
                    </ul>
                </div>

                <div data-aos="fade-right" data-duration="500" data-aos-delay="700" className="roadmap__item">
                    <div>
                        <h5>Phase 2</h5>
                    </div>
                    <div className="bg-overlay"></div>
                    <span className="side__line"></span>
                    <ul>
                        <li>Team expansion</li>
                        <li>Development of platform</li>
                        <li>Token launch</li>
                    </ul>
                </div>

                <div data-aos="fade-right" data-duration="500" data-aos-delay="1400" className="roadmap__item">
                    <div>
                        <h5>Phase 3</h5>
                    </div>
                    <div className="bg-overlay"></div>
                    <span className="side__line"></span>
                    <ul>
                        <li>Early Access and Beta testing</li>
                        <li>Onboarding pre-agreed clients</li>
                        <li>Migrate some existing client base over to Ladscatch NFT</li>
                    </ul>
                </div>
                <div data-aos="fade-right" data-duration="500" data-aos-delay="2000" className="roadmap__item">
                    <div>
                        <h5>Phase 4</h5>
                    </div>
                    <div className="bg-overlay"></div>
                    <span className="side__line"></span>
                    <ul>
                        <li>Interactive Seat map functionality</li>
                        <li>Community building features</li>
                        <li>Full Marketing Launch White label functionality</li>
                        <li>Affiliate scheme functionality</li>
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default RoadMap;